import "apps/BUDWEISERPOTM/assets/css/ui.css";
import "apps/BUDWEISERPOTM/assets/css/fonts.css";

import React, {lazy, Suspense} from "react";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {projectStore} from "apps/BUDWEISERPOTM/modules/store";
import {
	getProjectLink,
	secretKeyRedirect,
	prepareLanguageForRouter,
	PRESEASON,
	ProjectName,
	HIDE_SECRET_KEY,
	IS_PRODUCTION,
} from "modules";
import {
	ErrorModal,
	FAQs,
	Guideline,
	HelpLayout,
	HOCAuthRedirect,
	HOCi18n,
	HOCSession,
	LoginModal,
	NotAuthOnlyRoute,
	PagePreloader,
	PrivateRoute,
	Prizes,
	ShareModal,
	Terms,
	Privacy,
	Contact,
} from "components";
import {Provider} from "react-redux";
import {DefaultTheme, ThemeProvider} from "styled-components";
import {theme} from "apps/BUDWEISERPOTM/assets/css/theme";
import {helpLinks} from "apps/BUDWEISERPOTM/modules/constants";

if (!HIDE_SECRET_KEY) {
	secretKeyRedirect();
}

if (PRESEASON) {
	window.location.href = getProjectLink(ProjectName.Budweiserpotm);
}

const Landing = lazy(() => import("apps/BUDWEISERPOTM/pages/Landing"));
const NotFound = lazy(() => import("pages/NotFound"));
const Registration = lazy(() => import("pages/Registration"));
const Rankings = lazy(() => import("pages/Leaderboard"));
const Backdoor = lazy(() => import("pages/Backdoor"));

export const ProjectIndex: React.FC = () => {
	const baseName = prepareLanguageForRouter();

	return (
		<Provider store={projectStore}>
			<BrowserRouter basename={baseName}>
				<ThemeProvider theme={theme as unknown as DefaultTheme}>
					<HOCi18n>
						<HOCSession>
							<HOCAuthRedirect>
								<Suspense fallback={<PagePreloader />}>
									<Routes>
										<Route path="/">
											<Route index element={<Landing />} />
											<Route path="pool" element={<Landing />} />
										</Route>
										<Route element={<NotAuthOnlyRoute />}>
											<Route path="/register" element={<Registration />} />
											{IS_PRODUCTION ? null : (
												<Route path="/backdoor" element={<Backdoor />} />
											)}
										</Route>
										<Route path="/rankings" element={<Rankings />} />
										<Route element={<PrivateRoute />}>
											<Route path="/vote" element={<Landing />} />
										</Route>
										<Route
											path="/help/*"
											element={<HelpLayout links={helpLinks} />}>
											<Route path="guidelines" element={<Guideline />} />
											<Route path="prizes" element={<Prizes />} />
											<Route path="faqs" element={<FAQs />} />
											<Route path="contact" element={<Contact />} />
											<Route path="terms" element={<Terms />} />
											<Route path="privacy" element={<Privacy />} />

											<Route
												path="*"
												element={<Navigate to="/help/guidelines" />}
											/>
										</Route>

										<Route path="*" element={<NotFound />} />
									</Routes>
								</Suspense>
								<ErrorModal />
								<LoginModal />
								<ShareModal />
							</HOCAuthRedirect>
						</HOCSession>
					</HOCi18n>
				</ThemeProvider>
			</BrowserRouter>
		</Provider>
	);
};

export default ProjectIndex;
